import { render, staticRenderFns } from "./NutritionInstructionsPage.vue?vue&type=template&id=39e7b761&scoped=true"
import script from "./NutritionInstructionsPage.vue?vue&type=script&lang=js"
export * from "./NutritionInstructionsPage.vue?vue&type=script&lang=js"
import style0 from "./NutritionInstructionsPage.vue?vue&type=style&index=0&id=39e7b761&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e7b761",
  null
  
)

export default component.exports